export const PUBLIC_API_PREFIX = '/public-api';

export const STAGE_LABELS: Record<string, string> = {
	analyzing_text: 'Analyzing text...',
	detecting_type: 'Detecting document type...',
	extracting_data: 'Extracting data...',
	reading_file: 'Reading file...',
	saving: 'Saving...',
	uploading: 'Uploading...',
};